import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { AIPage } from '@/features/distri-ai/pages/AIPage'
import { AI_TAB_KEYS } from '@/features/distri-ai/types'

const searchSchema = z.object({
  tab: z.enum(AI_TAB_KEYS).catch('digest'),
})

export const Route = createFileRoute('/_app/ai/')({
  validateSearch: searchSchema,
  component: AIPage,
})
